var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2548 41H10.7457C7.02587 41 4 38.0211 4 34.3591V16.6409C4 12.9793 7.02633 10 10.7457 10H39.2548C42.9741 10 46 12.9793 46 16.6409V34.3591C46 38.0211 42.9741 41 39.2548 41ZM10.7457 11.942C8.11367 11.942 5.9726 14.0498 5.9726 16.6409V34.3591C5.9726 36.9502 8.11367 39.0585 10.7457 39.0585H39.2548C41.8868 39.0585 44.0279 36.9502 44.0279 34.3591V16.6409C44.0279 14.0498 41.8868 11.942 39.2548 11.942H10.7457Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15389 16.7331C14.1958 21.5699 19.2376 26.4061 24.2795 31.2429C25.2194 32.1442 26.6618 30.7274 25.7206 29.8242C20.6787 24.9879 15.6368 20.1512 10.595 15.3149C9.65509 14.4131 8.21262 15.8304 9.15389 16.7331Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7206 31.243C30.7624 26.4068 35.8043 21.5701 40.8462 16.7338C41.787 15.831 40.3454 14.4133 39.4051 15.3151C34.3632 20.1514 29.3214 24.9881 24.2795 29.8244C23.3387 30.7271 24.7802 32.1449 25.7206 31.243Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7906 34.6665C37.4358 31.5342 34.0804 28.4023 30.7256 25.27C29.774 24.382 28.3306 25.7979 29.2845 26.6887C32.6394 29.821 35.9947 32.9528 39.3496 36.0851C40.3011 36.9732 41.7445 35.5568 40.7906 34.6665Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7415 36.0848C14.0963 32.9525 17.4517 29.8207 20.8065 26.6884C21.7599 25.798 20.3175 24.3812 19.3655 25.2697C16.0106 28.402 12.6553 31.5338 9.30039 34.6661C8.34699 35.5565 9.78945 36.9738 10.7415 36.0848Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailing);
export default __webpack_public_path__ + "static/media/mailing.b65903db.svg";
export { ForwardRef as ReactComponent };